import React from 'react';
import { TextField, InputAdornment, Box } from '@mui/material';

interface ColorPickerFieldProps {
  label: string;
  value?: string;
  onChange: (color: string) => void;
  fullWidth?: boolean;
}

const ColorPickerField: React.FC<ColorPickerFieldProps> = ({
  label,
  value,
  onChange,
  fullWidth = true,
}) => (
  <TextField
    label={label}
    value={value || ''}
    onChange={(e) => onChange(e.target.value)}
    fullWidth={fullWidth}
    type="text"
    placeholder="#000000"
    helperText="Enter a hex color code (e.g., #FF5722)"
    InputProps={{
      startAdornment: value && (
        <InputAdornment position="start">
          <Box
            sx={{
              width: 24,
              height: 24,
              backgroundColor: value,
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          />
        </InputAdornment>
      ),
    }}
  />
);

export default ColorPickerField;
